import * as React from "react";
import { styled } from "@mui/system";
import MUILinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";

export const LinearProgress = styled(
  (props: LinearProgressProps) => <MUILinearProgress {...props} />,
  {
    name: "LinearProgress",
    slot: "Root",
    overridesResolver: (props, styles) => [],
  }
)(({ theme }) => ({
  height: 8,
  borderRadius: 0,
  "& .MuiLinearProgress-bar": {
    borderRadius: 0,
    background: theme.palette.primary.baseVaporGradient,
  },
  "&.MuiLinearProgress-root.MuiLinearProgress-colorPrimary.MuiLinearProgress-determinate":
    {
      background: theme.palette.primary.neutral10Color,
    },
  "&.MuiLinearProgress-root.MuiLinearProgress-colorPrimary.MuiLinearProgress-indeterminate":
    {
      background: theme.palette.primary.neutral10Color,
    },
}));
